import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Linkedin, Menu, X } from 'lucide-react';

const Header = ({ onBookCall }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Vorteile', href: '#benefits' },
    { label: 'Prozess', href: '#process' },
    { label: 'Testimonials', href: '#testimonials' },
    { label: 'Kontakt', href: '#contact' }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-lg' 
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="/2besales-logo.png" 
              alt="2besales Logo" 
              className="h-10 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-slate-700 hover:text-blue-600 font-medium transition-colors duration-200"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <a 
              href="https://calendly.com/patrick-2besales/linkedin-ai-agent-beratungsgesprach"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button 
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-2 transition-all duration-300 hover:shadow-lg"
              >
                CEO-Strategietermin
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-slate-900"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-4 animate-in slide-in-from-top">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="block text-slate-700 hover:text-blue-600 font-medium py-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <a 
              href="https://calendly.com/patrick-2besales/linkedin-ai-agent-beratungsgesprach"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button 
                onClick={() => setIsMobileMenuOpen(false)}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold"
              >
                CEO-Strategietermin
              </Button>
            </a>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
